import { Component, Output, EventEmitter } from '@angular/core';
import {SIDE_NAV_TITLES} from "../../../common/it-constants";
import {convertToSnakeCase} from "../../../common/it-utils";
import {LOAD_SVG_RESOURCES} from "../../../common/it-svg-util";

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent {

  @Output() selectedMenu = new EventEmitter<string>();

  isMenuOpen = false;
  selectedItem = localStorage.getItem('selectedItem') ?
  localStorage.getItem('selectedItem') : convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);

  fdeReportBlackIconUrl: string = LOAD_SVG_RESOURCES.fundDayEndReportBlackIcon;
  fdeReportWhiteIconUrl: string = LOAD_SVG_RESOURCES.fundDayEndReportWhiteIcon;
  newSecurityBlackIconUrl: string = LOAD_SVG_RESOURCES.newSecurityBlackIcon;
  newSecurityWhiteIconUrl: string = LOAD_SVG_RESOURCES.newSecurityWhiteIcon;

  fundDayEndReport = convertToSnakeCase(SIDE_NAV_TITLES.fundDayEndReport);
  newSecurity = convertToSnakeCase(SIDE_NAV_TITLES.newSecurity);
  // clientMappingKey = convertToSnakeCase(SIDE_NAVE_TITLES.clientMapping);

  constructor() { }

  toggleSideMenu(flag) {
    this.isMenuOpen = !flag;

    if (this.isMenuOpen) {
      document.getElementById('side_nav-id').style.width = '4%';
      document.getElementById('init-width').style.width = '4%';
      document.getElementById('container-Id').style.width = '96%';

    } else {
      document.getElementById('init-width').style.width = '15%';
      document.getElementById('side_nav-id').style.width = '15%';
      document.getElementById('container-Id').style.width = '82%';
    }

  }

  onClickTab(index) {
    this.selectedItem = index;
    this.selectedMenu.emit(index);
  }
}
